import { StrikePlate, StrikePlateShapeType } from 'metalworks-domain'

import { configuratorInterface } from '../configurator-interface'

/**
 * This transformer set correct horizontal length for T-Strike plates.
 *
 * Horizontal length actually can't be edited directly. User instead edits "main" and "tongue" widths,
 * which should be added together to get the correct horizontal length.
 *
 * This means that any change of "main width" should be reflected in the horizontal length.
 * And the same should happen when "tongue" width is changed.
 */
export const tStrikeLengthUpdateTransformer = configuratorInterface.transformerBuilder.when
  .entity([StrikePlate.type])
  .modified({ atFields: ['horizontalLength'] })
  .then.overrideMatchingUpdate(ctx => {
    const oldPlate = ctx.getOld$Root()

    if (!StrikePlate.is(oldPlate) || oldPlate.shapeType !== StrikePlateShapeType.TStrike) {
      return [ctx.update]
    }

    // Accept only updates from special "fake" dimension input for virtual "main width" attribute.
    const instanceName = ctx.update.origin?.componentInstance.instanceName
    if (instanceName !== 'tStrikeMainWidth') {
      return [ctx.update]
    }

    const newHorizontalLength = ctx.update.stateDelta.horizontalLength + oldPlate.tongueHorizontalLength
    const update = configuratorInterface.updates.DomainEntityModification({
      entityId: oldPlate.id,
      stateDelta: {
        horizontalLength: newHorizontalLength,
      },
      updateTag: 'tStrikeLengthUpdate',
    })

    return [update]
  })
  .build('Update T-Strike main width')

export const tStrikeTongueLengthUpdateTransformer = configuratorInterface.transformerBuilder.when
  .entity([StrikePlate.type])
  .modified({ atFields: ['tongueHorizontalLength'] })
  .then.overrideMatchingUpdate(ctx => {
    const oldPlate = ctx.getOld$Root()

    if (!StrikePlate.is(oldPlate) || oldPlate.shapeType !== StrikePlateShapeType.TStrike) {
      return [ctx.update]
    }

    const oldMainWidth = oldPlate.horizontalLength - oldPlate.tongueHorizontalLength
    const newTongueHorizontalLength = ctx.update.stateDelta.tongueHorizontalLength
    const newHorizontalLength = oldMainWidth + newTongueHorizontalLength

    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId: oldPlate.id,
        stateDelta: {
          tongueHorizontalLength: newTongueHorizontalLength,
          horizontalLength: newHorizontalLength,
        },
        updateTag: 'tStrikeTongueLengthUpdate',
      }),
    ]
  })
  .build('Update T-Strike main width')
